// jsonLDData.js
const jsonLDData = [    
  {                                                                    
    "@context": "https://schema.org",                                         
    "@graph": [   

      {           
        "@type": "Organization",
        "@id": "https://www.vantagecircle.com/#organization",
        "name": "Vantage Circle",
        "url": "https://www.vantagecircle.com/",
        "logo": {
          "@type": "ImageObject",
          "@id": "https://www.vantagecircle.com/#logo",
          "url": "https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2023/07/new-vc-logo.png",
          "caption": "Vantage Circle"
        },
        "description": "Vantage Circle is a global AI-enabled employee engagement platform offering solutions for rewards and recognition, corporate wellness, employee feedback, and corporate discounts.",
        "foundingDate": "2011",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Plano",
          "addressRegion": "TX",
          "addressCountry": "US"
        },
        "sameAs": [
          "https://www.linkedin.com/company/vantage-circle",
          "https://twitter.com/VantageCircle",
          "https://www.facebook.com/vantagecircle/",
          "https://www.instagram.com/vantagecircle/"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "support@vantagecircle.com",
          "contactType": "Customer Service"
        },
        "parentOrganization": {
          "@type": "Organization",
          "@id": "https://www.bargaintechnologies.in/#organization",
          "name": "Bargain Technologies Private Limited",
          "url": "https://www.bargaintechnologies.in/",
          "foundingDate": "2010-10-28",
          "founder": [
            {
              "@type": "Person",
              "name": "Partha Neog",
              "jobTitle": "CEO",
              "sameAs": "https://in.linkedin.com/in/parthaneog"
            },
            {
              "@type": "Person",
              "name": "Anjan Pathak",
              "jobTitle": "CTO",
              "sameAs": "https://in.linkedin.com/in/anjanp"
            }
          ],
          "sameAs": [
            "https://in.linkedin.com/company/bargain-technologies-pvt-ltd.",
            "https://www.crunchbase.com/organization/bargain-technologies"
          ]
        }
      },

      {
        "@type": "WebSite",
        "@id": "https://www.vantagefit.io/#website",
        "url": "https://www.vantagefit.io/",
        "name": "Vantage Fit",
        "description": "A Global Employee Wellness Platform for Corporates",
        "publisher": {
          "@id": "https://www.vantagecircle.com/#organization"
        },
        "inLanguage": "en-US",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.vantagefit.io/search?q={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      },

      {
        "@type": "WebPage",
        "@id": "https://www.vantagefit.io/#webpage",
        "url": "https://www.vantagefit.io/",
        "name": "Vantage Fit — A Global Employee Wellness Platform for Corporates",
        "description": "Vantage Fit is an AI-powered corporate wellness platform that helps organizations build a culture of health through activity tracking, fitness challenges, wellness rewards, and wearable integrations.",
        "inLanguage": "en-US",
        "isPartOf": {
          "@id": "https://www.vantagefit.io/#website"
        },
        "about": {
          "@id": "https://www.vantagefit.io/#software"
        },
        "publisher": {
          "@id": "https://www.vantagecircle.com/#organization"
        }
      },

      {
        "@type": "SoftwareApplication",
        "@id": "https://www.vantagefit.io/#software",
        "name": "Vantage Fit",
        "alternateName": "Vantage Fit — Corporate Wellness Platform",
        "applicationCategory": "HealthApplication",
        "applicationSubCategory": "Corporate Wellness",
        "operatingSystem": "iOS, Android, Web",
        "url": "https://www.vantagefit.io/",
        "description": "Vantage Fit is an AI-powered corporate wellness platform for corporates. It supports physical, mental, social, and emotional wellness through activity tracking, fitness challenges, nutrition logging, mood tracking, real-time leaderboards, and wellness rewards.",
        "featureList": [
          "Activity and step tracking",
          "GPS-based outdoor workout mapping",
          "Heart rate monitoring",
          "Nutrition and meal logging",
          "Mood tracking",
          "Hydration reminders",
          "Wellness challenges and contests",
          "Real-time leaderboards",
          "Reward points for wellness milestones",
          "Integration with Apple Watch, Fitbit, Garmin, Google Fit, Samsung Health",
          "Admin dashboard for HR teams",
          "Slack integration"
        ],
        "applicationSuite": "Vantage Circle",
        "offers": {
          "@type": "Offer",
          "url": "https://www.vantagefit.io/request-demo/",
          "category": "Software as a Service",
          "availability": "https://schema.org/InStock",
          "seller": {
            "@id": "https://www.vantagecircle.com/#organization"
          }
        },
        "creator": {
          "@id": "https://www.vantagecircle.com/#organization"
        },
        "provider": {
          "@id": "https://www.vantagecircle.com/#organization"
        },
        "sameAs": [
          "https://www.linkedin.com/showcase/vantagefit/",
          "https://www.facebook.com/Vantagefit-114318070217339/",
          "https://twitter.com/FitVantage",
          "https://www.instagram.com/vantage_fit/",
          "https://www.youtube.com/channel/UCA_X-JntyyNU6rjeRQWHE2w/",
          "https://apps.apple.com/us/app/vantage-fit/id1393594182"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "url": "https://www.vantagefit.io/request-demo/",
            "contactType": "Sales"
          },
          {
            "@type": "ContactPoint",
            "url": "https://www.vantagefit.io/partnership/",
            "contactType": "Partnership"
          }
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "570"
        },
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Organization", "name": "G2" },
            "url": "https://www.g2.com/products/vantage-fit/reviews",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "4.5",
              "bestRating": "5"
            },
            "reviewBody": "Being able to track and see everyone's status through a challenge is so thrilling. It definitely encourages a little friendly competition.",
            "datePublished": "2024-10-05"
          },
          {
            "@type": "Review",
            "author": { "@type": "Organization", "name": "Capterra" },
            "url": "https://www.capterra.com/p/203333/Vantage-Fit/",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "4.5",
              "bestRating": "5"
            },
            "reviewBody": "Easy integration with Google Fit and various other services. Support for smart watches. Easy to create campaigns and track progress.",
            "datePublished": "2022-08-22"
          },
          {
            "@type": "Review",
            "author": { "@type": "Organization", "name": "Gartner" },
            "url": "https://www.gartner.com/reviews/market/employee-well-being-solutions/vendor/vantage-circle/product/vantage-fit",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "4.8",
              "bestRating": "5"
            },
            "reviewBody": "Vantage Fit is a comprehensive fitness app that helps monitor and improve the physical fitness of employees with features like step count, nutrition and hydration intake.",
            "datePublished": "2024-07-03"
          }
        ]
      },

      {
        "@type": "MobileApplication",
        "@id": "https://www.vantagefit.io/#app-android",
        "name": "Vantage Fit App",
        "operatingSystem": "Android",
        "applicationCategory": "HealthApplication",
        "downloadUrl": "https://play.google.com/store/apps/details?id=com.bargaintechnologies.vantagefit.v_fit",
        "creator": { "@id": "https://www.vantagecircle.com/#organization" },
        "publisher": { "@id": "https://www.bargaintechnologies.in/#organization" },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.5",
          "reviewCount": "37800"
        }
      },

      {
        "@type": "MobileApplication",
        "@id": "https://www.vantagefit.io/#app-ios",
        "name": "Vantage Fit App",
        "operatingSystem": "iOS",
        "applicationCategory": "HealthApplication",
        "downloadUrl": "https://apps.apple.com/in/app/vantage-fit/id1393594182",
        "creator": { "@id": "https://www.vantagecircle.com/#organization" },
        "publisher": { "@id": "https://www.bargaintechnologies.in/#organization" },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "42"
        }
      }

    ]
  }
]

export default jsonLDData;
